import React from 'react';
import Head from 'next/head';
import MyFavoritesWrapper from '@components/MyFavorites/MyFavoritesWrapper';

const pageTitle = 'My Favorites | ResortPass';

export default function MyFavoritesPages() {
  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta property="og:title" content={pageTitle} key="title" />
      </Head>

      <main className="bg-white text-rp-primary-black pb-3.5 mb-10 w-full">
        <MyFavoritesWrapper />
      </main>
    </>
  );
}
